import { render, staticRenderFns } from "./SignupSection.vue?vue&type=template&id=a969f25e&"
import script from "./SignupSection.vue?vue&type=script&lang=js&"
export * from "./SignupSection.vue?vue&type=script&lang=js&"
import style0 from "./SignupSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports